import script from "./historyOrCollection.vue?vue&type=script&lang=ts&setup=true"
export * from "./historyOrCollection.vue?vue&type=script&lang=ts&setup=true"

import "./historyOrCollection.vue?vue&type=style&index=0&id=be597798&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be597798"]])

export default __exports__